<svg viewBox="0 0 35 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.46072 7.97842L16.1704 0.321358C16.5787 0.109175 17.0356 -0.00195312 17.4999 -0.00195312C17.9642 -0.00195312 18.4212 0.109175 18.8294 0.321358L33.5359 7.97527C36.0767 9.29762 35.0984 12.9971 32.2064 12.9971H2.79021C-0.0985553 13.0002 -1.08007 9.30077 1.46072 7.97842Z" fill="#33EB40"/>
</svg>
